<div
  class="permission-menu"
  [class.permission-menu--sidebar]="viewMode === 'sidebar'"
  [class.permission-menu--embedded]="viewMode === 'embedded'">
  <!-- Mesmo conteúdo do menu flutuante: scroll + colunas. -->
  <ng-container *ngIf="viewMode === 'sidebar'">
    <ng-scrollbar [visibility]="'hover'" orientation="vertical" externalViewport=".scroll-content">
      <div class="scroll-content">
        <ng-container *ngTemplateOutlet="readColumn"></ng-container>
        <div class="permission-edit-view" *ngIf="type == 'page' || type == 'homepage'">
          <ng-container *ngTemplateOutlet="editColumn"></ng-container>
        </div>
        <ng-container *ngIf="type == 'page' || type == 'homepage'">
          <ng-container *ngTemplateOutlet="segregationFooter"></ng-container>
        </ng-container>
      </div>
    </ng-scrollbar>
  </ng-container>

  <!-- Layout new-edit: duas colunas (mock) + mesma lógica de grupos. -->
  <ng-container *ngIf="viewMode === 'embedded'">
    <div class="publicacao-perm-embed">
      <div class="form-row publicacao-perm-cols">
        <div>
          <div class="publicacao-perm-box">
            <h3 class="publicacao-perm-h3 publicacao-perm-h3--view">
              👁️ Quem Pode Visualizar?
              <mmp-tooltip
                *ngIf="type == 'page' || type == 'homepage'"
                class="tooltip-view-desc"
                [text]="'Esta regra aplica-se a todas as subpáginas, desde que não tenha sido sobrescrita em níveis mais profundos da navegação.'">
              </mmp-tooltip>
            </h3>
            <ng-container *ngTemplateOutlet="readListBody"></ng-container>
          </div>
        </div>
        <div *ngIf="type == 'page' || type == 'homepage'">
          <div class="publicacao-perm-box">
            <h3 class="publicacao-perm-h3 publicacao-perm-h3--edit">
              ✏️ Quem Pode Editar?
              <mmp-tooltip
                *ngIf="type == 'page' || type == 'homepage'"
                class="tooltip-view-desc"
                [text]="'Esta regra aplica-se a todas as subpáginas, desde que não tenha sido sobrescrita em níveis mais profundos da navegação.'">
              </mmp-tooltip>
            </h3>
            <ng-container *ngTemplateOutlet="editListBody"></ng-container>
          </div>
        </div>
      </div>
      <ng-container *ngIf="type == 'page' || type == 'homepage'">
        <ng-container *ngTemplateOutlet="segregationFooter"></ng-container>
      </ng-container>
    </div>
  </ng-container>
</div>

<ng-template #readColumn>
  <div class="permission-desc">
    <p
      [innerHTML]="(('content.permission.permissionView' + type) | translate) + ': ' + (itemName ? itemName : '')"></p>
    <mmp-tooltip
      *ngIf="type == 'page' || type == 'homepage'"
      class="tooltip-view-desc"
      [text]="'Esta regra aplica-se a todas as subpáginas, desde que não tenha sido sobrescrita em níveis mais profundos da navegação.'">
    </mmp-tooltip>
  </div>
  <ng-container *ngTemplateOutlet="readListBody"></ng-container>
</ng-template>

<ng-template #readListBody>
  <div class="permision-view-list">
    <mm-list-item-picker
      [items]="readGroupsList"
      [type]="itemSegregated ? 'edit' : 'view'"
      [formControl]="permissionViewControl"
      [attribute]="'name'"
      [searchFn]="searchGroups.bind(this, 'read')"
      (selected)="populateList($event?.items, 'read', $event.type)">
      <p>{{ 'content.permission.emptyViewGroups.' + type | translate }}</p>
      <p>{{ 'cms.content.menu.usersCanView' | translate }}</p>
    </mm-list-item-picker>
  </div>
</ng-template>

<ng-template #editColumn>
  <div class="permission-desc mt-2">
    <p
      [innerHTML]="(('content.permission.permissionEdit' + type) | translate) + ': ' + (itemName ? itemName : '')"></p>
    <mmp-tooltip
      *ngIf="type == 'page' || type == 'homepage'"
      class="tooltip-view-desc"
      [text]="'Esta regra aplica-se a todas as subpáginas, desde que não tenha sido sobrescrita em níveis mais profundos da navegação.'">
    </mmp-tooltip>
  </div>
  <ng-container *ngTemplateOutlet="editListBody"></ng-container>
</ng-template>

<ng-template #editListBody>
  <div class="permision-view-list">
    <mm-list-item-picker
      [items]="writeGroupsList"
      [type]="itemSegregated ? 'edit' : 'view'"
      [formControl]="permissionEditControl"
      [attribute]="'name'"
      [searchFn]="searchGroups.bind(this, 'write')"
      (selected)="populateList($event?.items, 'write', $event.type)">
      <p>{{ areaText }} {{ 'cms.content.menu.editingRules' | translate }}</p>
      <p>{{ 'cms.content.menu.onlyAccessProfile' | translate }}</p>
    </mm-list-item-picker>
  </div>
</ng-template>

<ng-template #segregationFooter>
  <div class="footer-content" *ngIf="type == 'page' || type == 'homepage'">
    <hr />
    <h5>{{ 'cms.content.menu.segregationPages' | translate }}</h5>
    <div class="inherit-segregation" *ngIf="!itemSegregated">
      <p>{{ 'cms.content.menu.thisPageIsCurrentlyInheriting' | translate }}</p>
      <div class="d-flex justify-content-end">
        <div class="position-relative">
          <mm-toast *ngIf="showToast" [config]="toastConfig">
            <div>
              <p>
                {{ areaText }} {{ 'cms.content.menu.willLongerInherit' | translate }}
              </p>
              <div class="d-flex justify-content-end">
                <button class="btn btn-outline-dark btn-small me-1" (click)="showToast = false">
                  {{ 'button.cancel' | translate }}
                </button>
                <button class="btn btn-secondary btn-small" (click)="segregateItem(); showToast = false">
                  {{ 'button.continue' | translate }}
                </button>
              </div>
            </div>
          </mm-toast>
          <button class="btn btn-secondary" (click)="showToast = true">
            <mmp5-mm-icons [icon]="['icon', 'icon-grupos-usuarios-plus']"></mmp5-mm-icons>
            {{ 'cms.content.menu.segregate' | translate }} {{ areaText?.toLowerCase() }}
          </button>
        </div>
      </div>
    </div>
    <div class="item-segregated" *ngIf="itemSegregated">
      <p>
        {{ 'cms.content.menu.rightNow' | translate }} <strong>{{ 'cms.content.menu.segregated' | translate }}</strong>
        {{ 'cms.content.menu.andItsViewingEditing' | translate }}
      </p>
      <p>
        {{ 'cms.content.menu.youRemove' | translate }} {{ areaText?.toLowerCase() }}
        {{ 'cms.content.menu.reinheritAccess' | translate }}
      </p>
      <div class="d-flex justify-content-end">
        <div class="position-relative">
          <mm-toast *ngIf="showToast" [config]="toastConfig">
            <div>
              <p>{{ 'cms.content.menu.thisAndAllPages' | translate }}</p>
              <div class="d-flex justify-content-end">
                <button class="btn btn-outline-dark btn-small me-1" (click)="showToast = false">
                  {{ 'button.cancel' | translate }}
                </button>
                <button class="btn btn-secondary btn-small" (click)="removeSegregateItem(); showToast = false">
                  {{ 'button.continue' | translate }}
                </button>
              </div>
            </div>
          </mm-toast>
          <button class="btn btn-danger" (click)="showToast = true">
            <mmp5-mm-icons [icon]="['icon', 'icon-toolbar-apagar']"></mmp5-mm-icons>
            {{ 'cms.content.menu.segregateRemove' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
